module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pictureList.length > 0) ? _c('viewer', {
    ref: "viewer",
    staticClass: "picture-view-box",
    attrs: {
      "images": _vm.pictureList,
      "rebuild": "",
      "options": {
        initialViewIndex: 0,
        navbar: false,
        title: function () { return _vm.item.fileTitle; }
      }
    }
  }, _vm._l((_vm.pictureList), function(pic) {
    return _c('div', {
      key: pic.id,
      staticClass: "pic-list"
    }, [_c('img', {
      staticClass: "item-pic",
      attrs: {
        "src": pic.pic,
        "alt": ""
      }
    }), _vm._v(" "), (_vm.isShowFt) ? _c('h4', {
      staticClass: "pic-label"
    }, [_vm._t("default", function() {
      return [_vm._v(_vm._s(pic.fileName))]
    })], 2) : _vm._e()])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587a3e18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PictureList.vue
// module id = 1799
// module chunks = 9